export default "__VITE_ASSET__BUiVBHQu__"